import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faMagnifyingGlass, faPrint, faTrash } from '@fortawesome/free-solid-svg-icons'
import { Divider, Empty, message, Popconfirm, Table, Tooltip } from 'antd'

import EditServiceResultModal from './EditServiceResultModal'
import Pagination from '../../../components/Pagination'

import { deleteServiceResult } from '../services'
import { handleError } from '../../../helpers'

export default function ServiceResultsTable({ serviceResults, reload, pagination, setPagination }) {
	const [editModalRecord, setEditModalRecord] = useState(null)
	
	const columns = [
		{
			title: 'Consecutivo',
			dataIndex: 'sku',
			render: (t, r) => <Link to={`/service_results/${r.id}`}>{t}</Link>
		},
		{
			title: 'Empresa',
			dataIndex: 'service_report',
			render: t => t.service.location ? t.service.location.company.legal_name : <em>Sede eliminada</em>
		},
		{
			title: 'Sede',
			dataIndex: 'service_report',
			render: t => t.service.location ? t.service.location.name : <em>Sede eliminada</em>
		},
		{
			title: 'Elaborado por',
			dataIndex: 'elaborate_by'
		},
		{
			title: 'Fecha de creación',
			dataIndex: 'created_at',
		},
		{
			title: 'Acciones',
			width: '125px',
			render: (t, r) => (
				<React.Fragment>
					<Tooltip title="Abrir Informe">
						<React.Fragment>
							<Link to={`/service_results/${r.id}`}>
								<FontAwesomeIcon icon={faMagnifyingGlass} className="text-link" />
							</Link>
						</React.Fragment>
					</Tooltip>
					<Divider type='vertical' />
					<Tooltip title="Imprimir Informe">
						<React.Fragment>
							<Link to={`/service_results/preview/${r.id}`} target="_blank">
								<FontAwesomeIcon icon={faPrint} className="text-link" />
							</Link>
						</React.Fragment>
					</Tooltip>
					<Divider type='vertical' />
					<Tooltip title="Editar" onClick={() => setEditModalRecord(r)}>
						<React.Fragment>
							<FontAwesomeIcon icon={faEdit} className="text-link" />
						</React.Fragment>
					</Tooltip>
					<Divider type='vertical' />
					<Tooltip title="Eliminar">
						<React.Fragment>
							<Popconfirm
								title="Esta acción no se puede revertir"
								okText="Eliminar"
								cancelText="Cancelar"
								okButtonProps={{ danger:true }}
								onConfirm={() => handleDelete(r.id)}
							>
								<FontAwesomeIcon icon={faTrash} className="text-link" />
							</Popconfirm>
						</React.Fragment>
					</Tooltip>
				</React.Fragment>
			)
		}
	]

	const handleDelete = id => {
		deleteServiceResult(id)
			.then(res => {
				message.success(res.data.message)
				reload()
			})
			.catch(handleError)
	}
	
	return (
		<React.Fragment>
			<Table 
				dataSource={serviceResults}
				rowKey={r => r.id}
				pagination={false}
				columns={columns}
				loading={!serviceResults}
				size="small"
				locale={{ emptyText: (
					<Empty
						description="No se encontraron registros" 
						styles={{ image: { height: '80px' } }}
					/> 
				)}}
			/>
			<Pagination 
				pagination={pagination}
				setPagination={setPagination}
				reload={reload}
				className="mb-0"
			/>
			{ editModalRecord && (
				<EditServiceResultModal 
					visible
					onClose={() => setEditModalRecord(null)}
					serviceResult={editModalRecord}
					reload={reload}
				/>
			)}
		</React.Fragment>
	)
}